import { render, staticRenderFns } from "./NewOrExistingPatient.vue?vue&type=template&id=e3d11caa"
import script from "./NewOrExistingPatient.vue?vue&type=script&lang=js"
export * from "./NewOrExistingPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports